import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e20d740")

_pushScopeId("data-v-4e20d740")
const _hoisted_1 = { class: "mobile-actions-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "mobile-actions-footer-cancel",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.backEmit())),
      type: "button"
    }, _toDisplayString(_ctx.$t('button.cancel')), 1),
    _createVNode("button", {
      class: "mobile-actions-footer-save",
      disabled: !_ctx.calculated,
      type: "submit",
      form: _ctx.fromId
    }, _toDisplayString(_ctx.submitText ?? _ctx.$t('button.add')), 9, ["disabled", "form"])
  ]))
})